import { QUERY_KEYS } from "../../lib/query-constants"
import { useGenericQuery } from "../use-generic-query"


export const useDestinations = ({ endpoint = "integration" } = {}) => {
    return useGenericQuery({
        queryKey: QUERY_KEYS.destinations.all,
        endpoint,
        onError: () => { },
        onSuccess: () => { },
        staleTime: Infinity,
    })
}